export function emailedSentence(names: string[]): string {
    if (names.length === 0) {
        return 'No one else to email.'
    }

    const listed =
        names.length === 1 ? names[0] : `${names.slice(0, -1).join(', ')} and ${names.at(-1)}`
    return `Emailed ${listed}.`
}
